export function extractUniqueKeyValues(arrayOfObjects: any, keyName: string) {
    const uniqueValues = new Set();
    arrayOfObjects.forEach((obj: any) => uniqueValues.add(obj[keyName]));
    return Array.from(uniqueValues);
}

export function groupBy(data: any, key: number) {
    return data.reduce((acc: any, curr: any) => {
        (acc[curr[key]] = acc[curr[key]] || []).push(curr);
        return acc;
    }, {});
}

export const separarPorHR = (array: any) => {
    return array.reduce(
        (acc: any, item: any) => {
            if (item.type === 'hr') {
                acc.push([]);
            } else {
                acc[acc.length - 1].push(item);
            }
            return acc;
        },
        [[]],
    );
};
